import { render } from "./ClientDashboardView.vue?vue&type=template&id=24fa4c86&ts=true"
import script from "./ClientDashboardView.vue?vue&type=script&lang=ts"
export * from "./ClientDashboardView.vue?vue&type=script&lang=ts"

import "./ClientDashboardView.vue?vue&type=style&index=0&id=24fa4c86&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__